// etichette, colori e azioni dei consigli, condivise da pagina, menu e riepilogo

export const AREE = {
	magazzino: { label: 'Magazzino', icona: 'mdi-warehouse', colore: 'indigo' },
	prezzo: { label: 'Prezzo', icona: 'mdi-tag-outline', colore: 'deep-orange' },
	clienti: { label: 'Clienti', icona: 'mdi-account-group-outline', colore: 'teal' },
	marketing: { label: 'Marketing', icona: 'mdi-bullhorn-outline', colore: 'purple' },
	seo: { label: 'SEO', icona: 'mdi-magnify', colore: 'blue-grey' },
};

export const area = codice => AREE[codice] || { label: codice || '—', icona: 'mdi-lightbulb-outline', colore: 'grey' };

// schede della pagina: sono il filtro "type" della lista
export const TIPI = [
	{ value: '', label: 'Tutti i consigli', icona: 'mdi-lightbulb-on-outline' },
	{ value: 'viewed', label: 'Visti ma non comprati', icona: 'mdi-eye-outline' },
	{ value: 'radar', label: 'Radar opportunità', icona: 'mdi-radar' },
];

export const STATI = {
	open: { label: 'Da fare', icona: 'mdi-lightbulb-outline', colore: 'primary' },
	snoozed: { label: 'Rimandati', icona: 'mdi-clock-outline', colore: 'orange' },
	done: { label: 'Fatti', icona: 'mdi-check', colore: 'green' },
	dismissed: { label: 'Ignorati', icona: 'mdi-close', colore: 'grey' },
	resolved: { label: 'Risolti da soli', icona: 'mdi-check-all', colore: 'blue-grey' },
};

export const GRAVITA = {
	3: { label: 'Alta', colore: 'error' },
	2: { label: 'Media', colore: 'orange' },
	1: { label: 'Bassa', colore: 'grey' },
};

export const euro = v => (v === null || v === undefined || v === '' ? '—' : new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v));
export const euroCent = v => (v === null || v === undefined || v === '' ? '—' : new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v));
export const percento = v => (v === null || v === undefined ? '—' : `${String(Math.round(v * 100) / 100).replace('.', ',')}%`);

/**
 * Dove porta l'azione di un consiglio. Le pagine di destinazione esistono gia':
 * il consiglio le apre (gia' compilate dove si puo') e l'utente conferma li'.
 */
export function destinazione(insight, tipoAzione) {
	const a = (insight && insight.action) || {};
	const d = (insight && insight.data) || {};
	const p = a.params || {};
	switch (tipoAzione || a.type) {
		case 'simulator':
			return { path: '/insights/simulator' };
		case 'simulate':
			return { path: '/insights/simulator', query: { item: p.item, sku: d.sku || undefined, title: d.title || undefined, discount: p.discount } };
		case 'discount':
			// il nome dell'offerta compare sul sito accanto al prezzo: niente SKU o testi interni
			return { path: '/ecommerce/offers/new', query: { item: p.item, sku: d.sku || undefined, discount: p.discount, name: 'Offerta speciale' } };
		case 'coupon':
			return { path: '/ecommerce/coupon/new' };
		case 'reorder':
			return { path: '/riordino' };
		case 'competitor':
			return { path: '/competitor/analisi', query: { q: p.q || undefined } };
		case 'carts':
			return { path: '/cartabandoned' };
		case 'customers':
			return { path: '/ecommerce/coupon/new' };
		case 'dashboard':
			return { path: '/home' };
		// pubblicita': report con la campagna gia' cercata, impostazioni dei collegamenti
		case 'ads':
			return { path: '/ads', query: p.q ? { q: p.q } : {} };
		case 'adsSettings':
			return { path: '/setting/ads' };
		// Microsoft Clarity: Statistiche, scheda Comportamento
		case 'behavior':
			return { path: '/stats', query: { tab: 'comportamento' } };
		// mese sotto le attese: report finanziario, scheda Previsioni
		case 'forecast':
			return { path: '/finance', query: { tab: 'forecast' } };
		case 'items':
			return { path: '/items' };
		case 'seo':
		case 'rewrite':
		case 'openItem':
		case 'item':
			return d.item ? { path: `/items/${d.item}` } : null;
		default:
			return null;
	}
}
